import { render } from "./App.vue?vue&type=template&id=2d0724b0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2d0724b0&lang=scss"

import exportComponent from "/data/jenkins/workspace/staging-package-front-survey/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__